<template>
    <div class="section-box" style="min-height: 77vh;">
        <el-form inline label-width="100px" label-position="right" style="padding: 20px 14px 0 14px;">
            <el-form-item label="销售负责人：">
                <el-select 
                    size="medium"
                    filterable
                    v-model="form.principalId" 
                    placeholder="请选择"
                >
                    <el-option 
                        v-for="(item,index) in fzrList"
                        :label="item.principal" 
                        :value="item.principalId"
                        :key="index"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="时间：">
                <el-date-picker
                    size="medium"
                    v-model="time"
                    :clearable="false"
                    type="daterange"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                >
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button size="medium" type="primary" @click="handleSearch">查询</el-button>
            </el-form-item>
            <el-form-item>
                <el-button size="medium" type="success" @click="handleReset">重置</el-button>
            </el-form-item>
        </el-form>
        <div v-loading="dataLoading">
            <el-card shadow="always" style="margin: 30px 0">
                <el-row :gutter="20">
                    <el-col :md="5" :sm="24">
                        <div class="statistics-item">
                            <div class="item-number">{{dataStat.totalCustNum || 0}}</div>
                            <div class="item-subtitle">全部客户数</div>
                        </div>
                    </el-col>
                    <el-col :md="5" :sm="24">
                        <div class="statistics-item">
                            <div class="item-number">{{dataStat.unregCustNum || 0}}</div>
                            <div class="item-subtitle">未注册客户数</div>
                        </div>
                    </el-col>
                    <el-col :md="4" :sm="24">
                        <div class="statistics-item">
                            <div class="item-number">{{dataStat.regCustNum || 0}}</div>
                            <div class="item-subtitle">已注册客户数</div>
                        </div>
                    </el-col>
                    <el-col :md="5" :sm="24">
                        <div class="statistics-item">
                            <div class="item-number">{{dataStat.sigCustNum || 0}}</div>
                            <div class="item-subtitle">已签约客户数</div>
                        </div>
                    </el-col>
                    <el-col :md="5" :sm="24">
                        <div class="statistics-item">
                            <div class="item-number">{{dataStat.orderCustNum || 0}}</div>
                            <div class="item-subtitle">已成单客户数</div>
                        </div>
                    </el-col>
                </el-row>
            </el-card>
            <el-card shadow="always">
                <el-row :gutter="100">
                    <el-col :md="6" :sm="24">
                        <div class="statistics-item">
                            <div class="item-number">{{dataStat.totalOrderCustNum || 0}}</div>
                            <div class="item-subtitle">总成单数</div>
                        </div>
                    </el-col>
                    <el-col :md="6" :sm="24">
                        <div class="statistics-item">
                            <div class="item-number">{{dataStat.traceNum || 0}}</div>
                            <div class="item-subtitle">跟进次数</div>
                        </div>
                    </el-col>
                    <el-col :md="6" :sm="24">
                        <div class="statistics-item">
                            <div class="item-number">{{dataStat.businessNum || 0}}</div>
                            <div class="item-subtitle">商机数</div>
                        </div>
                    </el-col>
                    <el-col :md="6" :sm="24">
                        <div class="statistics-item">
                            <div class="item-number color-red">￥{{dataStat.totalOrderCustAmount | formatPrice}}</div>
                            <div class="item-subtitle">总成单金额</div>
                        </div>
                    </el-col>
                </el-row>
            </el-card>
        </div>
    </div>
</template>
<script>
    
    import {
        salesDataHeaders,                   //销售负责人
        statisticalData,                    //统计数据
    } from "@/service/customerInformation";
    export default {
        data() {
            return {
                dataLoading: false,
                form: {
                    principalId: '',            //负责人id
                },
                dataStat:{
                    totalCustNum: 0,
                    unregCustNum: 0,
                    regCustNum: 0,
                    sigCustNum: 0,
                    orderCustNum: 0,
                    totalOrderCustNum: 0,
                    traceNum: 0,
                    businessNum: 0,
                    totalOrderCustAmount: 0

                },                    //数据
                searchData:{},
                oraginForm:{},
                fzrList:[],         //销售负责人

                searchForm: {
                    beginTime: '',
                    reportTimeGt: ''
                }
            };
        },
        computed: {
            time: {
                get(){
                    return [this.searchForm.beginTime, this.searchForm.reportTimeGt]
                },
                set([beginTime,reportTimeGt]){
                    this.searchForm.beginTime = beginTime || ''
                    this.searchForm.reportTimeGt = reportTimeGt || ''
                },
            }
        },
        activated(){
            this.handleSearch()
        },
        created() {
            this.oraginForm = JSON.parse(JSON.stringify(this.form))
            this.tableData = [];
            this.getSalesDataHeaders();
            this.getCurrentMonthFirst();
            this.getCurrentMonthLast();
        },
        methods: {
            //设置默认日期
            getCurrentMonthFirst() {
                // 获取当年1月1号
                var date = new Date()
                date.setDate(1)
                this.searchForm.beginTime = date.getFullYear() + "-01" + "-01"
            },
            getCurrentMonthLast() {
                // 获取当天日期
                var date = new Date()
                var month = parseInt(date.getMonth() + 1)
                var day = date.getDate()
                if (month < 10) month = "0" + month
                if (day < 10) day = "0" + day
                this.searchForm.reportTimeGt = date.getFullYear() + "-" + month + "-" + day
            },





            // 获取销售负责人
            getSalesDataHeaders(){
                salesDataHeaders().then(res=> {
                    this.fzrList = res.Data
                })
            },
            // 查询
            handleSearch() {
                this.searchData = Object.assign({}, this.form)
                this.getStatisticalData()
            },
            // 重置
            handleReset() {
                this.form = JSON.parse(JSON.stringify(this.oraginForm))
                this.time = []
                this.handleSearch()
            },
            async getStatisticalData(){
                let data = JSON.parse(JSON.stringify(this.searchData))
                data.time = this.time
                if (data.time[0] && data.time[1]) {
                    data.timeBegin = data.time[0] + ' 00:00:01'
                    data.timeEnd = data.time[1] + ' 23:59:59'
                }
                delete data.time
                this.dataLoading = true
                let res = await statisticalData(data);
                this.dataLoading = false
                if(res.Result !=1 ) {
                    return this.$message.error('获取失败请联系开发人员')
                }
                this.dataStat = res.Data
            },
        }
    };
</script>
<style  lang="scss">
    .customer-row-bg {
        padding: 20px 14px;
        background-color: #f9fafc;
        display: flex;
        align-items: center;
        // .el-form-item {
        //     margin-bottom: 0 !important;
        // }
    }
    .statistics-item {
        text-align: center;
        .item-subtitle {
            font-size: 16px;
            line-height: 40px;
            font-weight: 500;
            color: #666666;
        }
        .item-number {
            font-size: 30px;
            font-weight: 600;
            line-height: 60px;
            color: #333333;
        }
        .color-red {
            color: #f75959;
        }
    }
</style>